import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import { type SFTPConfigurationData } from '../types'

const ZData = z.object({
  status: z.string(),
  message: z.string()
})

const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZData
})

export type ApiResponse = z.infer<typeof ZApiResponse>

export async function TestConnection (
  TestConnectionPostRequest: SFTPConfigurationData,
  onSuccess: (message: string, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/app-config-service/api/v1/udp/configure-protocol/testConnection'

  interceptedAxios
    .post(url, TestConnectionPostRequest)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data.message, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        // istanbul ignore else
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message ?? 'Unknown Error', error.response.data.http_status ?? error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}

export async function TestConnectionWithoutCredentials (
  protocolId: string,
  onSuccess: (message: string, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = `/app-config-service/api/v1/udp/configure-protocol/testConnection/${protocolId}`
  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data.message, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        // istanbul ignore else
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message ?? 'Unknown Error', error.response.data.http_status ?? error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
